import * as InternalUsersAPI from "@src/api/internalUsersAPI";
import { begin, failure, success } from "redux-api-status/actions";
import * as types from "./actionTypes";
import { Storage } from "aws-amplify";

const getStorageFileURL = async (url) => {
  try {
    return await Storage.get(url);
  } catch (error) {
    console.error("error accessing the Image from s3", error);
  }
};

export const WEBSOCKET_CONNECTED = "WEBSOCKET_CONNECTED";
export const WEBSOCKET_DISCONNECTED = "WEBSOCKET_DISCONNECTED";
export const WEBSOCKET_ERROR = "WEBSOCKET_ERROR";

export const websocketConnected = () => ({
  type: WEBSOCKET_CONNECTED,
});

export const websocketDisconnected = () => ({
  type: WEBSOCKET_DISCONNECTED,
});

export const websocketError = () => ({
  type: WEBSOCKET_ERROR,
});

export const loadInternalUser = (data) => async (dispatch) => {
  dispatch(begin(types.LOAD_INTERNALUSER));
  return InternalUsersAPI.getInternalUser(data)
    .then((loadedInternalUser) => {
      loadedInternalUser.data.avatarThumbnail
        ? getStorageFileURL(loadedInternalUser.data.avatarThumbnail).then(
            (result) => {
              loadedInternalUser.data.avatarThumbnailURL = result;

              dispatch(success(types.LOAD_INTERNALUSER, loadedInternalUser));
            }
          )
        : dispatch(success(types.LOAD_INTERNALUSER, loadedInternalUser));
    })
    .catch((error) => {
      console.log(error);
      dispatch(failure(types.LOAD_INTERNALUSER, error));
      throw error;
    });
};

export const loadInternalUsers = (data) => async (dispatch) => {
  dispatch(begin(types.LOAD_INTERNALUSERS));
  return InternalUsersAPI.getInternalUsers(data)
    .then((loadedInternalUsers) => {
      dispatch(success(types.LOAD_INTERNALUSERS, loadedInternalUsers));
    })
    .catch((error) => {
      dispatch(failure(types.LOAD_INTERNALUSERS, error));
      throw error;
    });
};
export const loadInternalNotifications = () => async (dispatch) => {
  dispatch(begin(types.LOAD_INTERNAL_NOTIFICATIONS));
  return InternalUsersAPI.getInternalNotifications()
    .then((loadedInternalUsers) => {
      dispatch(success(types.LOAD_INTERNAL_NOTIFICATIONS, loadedInternalUsers));
    })
    .catch((error) => {
      dispatch(failure(types.LOAD_INTERNAL_NOTIFICATIONS, error));
      throw error;
    });
};

export const loadListTypes = () => async (dispatch) => {
  dispatch(begin(types.LOAD_LISTTYPES));
  return InternalUsersAPI.getListTypes()
    .then((loadedInternalUsers) => {
      dispatch(success(types.LOAD_LISTTYPES, loadedInternalUsers));
    })
    .catch((error) => {
      dispatch(failure(types.LOAD_LISTTYPES, error));
      throw error;
    });
};

export const loadPolicyDocuments = () => async (dispatch) => {
  dispatch(begin(types.LOAD_POLICYDOCUMENTS));
  return InternalUsersAPI.getPolicyDocuments()
    .then((loadedInternalUsers) => {
      dispatch(success(types.LOAD_POLICYDOCUMENTS, loadedInternalUsers));
    })
    .catch((error) => {
      dispatch(failure(types.LOAD_POLICYDOCUMENTS, error));
      throw error;
    });
};
export const loadClientMarketingEmailTemplates = () => async (dispatch) => {
  dispatch(begin(types.LOAD_CLIENTMARKETINGEMAILTEMPLATES));
  return InternalUsersAPI.getClientMarketingEmailTemplates()
    .then((loadedInternalUsers) => {
      dispatch(
        success(types.LOAD_CLIENTMARKETINGEMAILTEMPLATES, loadedInternalUsers)
      );
    })
    .catch((error) => {
      dispatch(failure(types.LOAD_CLIENTMARKETINGEMAILTEMPLATES, error));
      throw error;
    });
};

export const loadStatsDays = (ownershipid) => async (dispatch) => {
  dispatch(begin(types.LOAD_STATS_DAYS));
  return InternalUsersAPI.getStatsDays(ownershipid)
    .then((loadedInternalUsers) => {
      dispatch(success(types.LOAD_STATS_DAYS, loadedInternalUsers));
    })
    .catch((error) => {
      dispatch(failure(types.LOAD_STATS_DAYS, error));
      throw error;
    });
};

export const loadRecentBookingStatus = () => async (dispatch) => {
  dispatch(begin(types.LOAD_STATS_RECENTBOOKINGSTATUS));
  return InternalUsersAPI.getRecentBookingStatus()
    .then((loadedInternalUsers) => {
      dispatch(
        success(types.LOAD_STATS_RECENTBOOKINGSTATUS, loadedInternalUsers)
      );
    })
    .catch((error) => {
      dispatch(failure(types.LOAD_STATS_RECENTBOOKINGSTATUS, error));
      throw error;
    });
};

export const loadWeekOnWeekStats = () => async (dispatch) => {
  dispatch(begin(types.LOAD_STATS_WEEKONWEEKSTATS));
  return InternalUsersAPI.getWeekOnWeekStats()
    .then((loadedInternalUsers) => {
      dispatch(success(types.LOAD_STATS_WEEKONWEEKSTATS, loadedInternalUsers));
    })
    .catch((error) => {
      dispatch(failure(types.LOAD_STATS_WEEKONWEEKSTATS, error));
      throw error;
    });
};

export const loadStatsClientContact = () => async (dispatch) => {
  dispatch(begin(types.LOAD_STATS_CLIENTCONTACT));
  return InternalUsersAPI.getStatsClientContact()
    .then((loadedInternalUsers) => {
      dispatch(success(types.LOAD_STATS_CLIENTCONTACT, loadedInternalUsers));
    })
    .catch((error) => {
      dispatch(failure(types.LOAD_STATS_CLIENTCONTACT, error));
      throw error;
    });
};

export const loadStatsCandidates = () => async (dispatch) => {
  dispatch(begin(types.LOAD_STATS_CANDIDATES));
  return InternalUsersAPI.getStatsCandidates()
    .then((loadedInternalUsers) => {
      dispatch(success(types.LOAD_STATS_CANDIDATES, loadedInternalUsers));
    })
    .catch((error) => {
      dispatch(failure(types.LOAD_STATS_CANDIDATES, error));
      throw error;
    });
};

export const updateInternalNotification = (id) => async (dispatch) => {
  dispatch(begin(types.UPDATE_INTERNAL_NOTIFICATIONS));
  return InternalUsersAPI.putInternalNotification(id)
    .then((loadedInternalUsers) => {
      dispatch(
        success(types.UPDATE_INTERNAL_NOTIFICATIONS, loadedInternalUsers)
      );
    })
    .catch((error) => {
      dispatch(failure(types.UPDATE_INTERNAL_NOTIFICATIONS, error));
      throw error;
    });
};

export const updateInternalNotificationOwner =
  (id, internalUserId) => async (dispatch) => {
    dispatch(begin(types.UPDATE_INTERNAL_NOTIFICATIONSOWNER));
    return InternalUsersAPI.putInternalNotificationOwner(id, internalUserId)
      .then((loadedInternalUsers) => {
        dispatch(
          success(types.UPDATE_INTERNAL_NOTIFICATIONSOWNER, loadedInternalUsers)
        );
      })
      .catch((error) => {
        dispatch(failure(types.UPDATE_INTERNAL_NOTIFICATIONSOWNER, error));
        throw error;
      });
  };

export const updateInternalUserAvatar = (data) => async (dispatch) => {
  dispatch(begin(types.UPDATE_INTERNALUSER_AVATAR));
  return InternalUsersAPI.putInternalUserAvatar(data)
    .then((loadedInternalUser) => {
      loadedInternalUser.data.avatarThumbnail
        ? getStorageFileURL(loadedInternalUser.data.avatarThumbnail).then(
            (result) => {
              loadedInternalUser.data.avatarThumbnailURL = result;

              dispatch(
                success(types.UPDATE_INTERNALUSER_AVATAR, loadedInternalUser)
              );
            }
          )
        : dispatch(
            success(types.UPDATE_INTERNALUSER_AVATAR, loadedInternalUser)
          );
    })
    .catch((error) => {
      dispatch(failure(types.UPDATE_INTERNALUSER_AVATAR, error));
      throw error;
    });
};
